import React, {useEffect, useContext} from 'react'
import { NavLink } from 'react-router-dom'
import Form from '../../components/Form'
import AOS from 'aos'; //animation library
import { MouseContext } from "../../context/mouseContext" //cursor 
import {projectsData} from '../../fake-database/index' //projects-data
import "aos/dist/aos.css"; //animation library style
import './projects.css'


const Projects = () => {
    const { cursorChangeHandler } = useContext(MouseContext); //cursor
    //aos animation init
    useEffect(() => {
        AOS.init({
            duration : 700
        });
    }, []);
    return (
        <section id="projects" className="projects text-white">
            <div className="row mx-0">
                <div className="col-md-5 col-12 ms-auto p-0">
                    <div className='projects-title'>
                        <h1 className=" text-uppercase pb-4" data-aos="fade-up">{projectsData.title}</h1>
                    </div>
                    <div className='position-relative d-md-block d-none projects-line'></div>
                </div>
            </div>

            <div className="mt-md-5 mt-sm-2">
                <div className="projects-main-photo">
                    {/* <img src={projectsData.project[0].imagePath} alt="" className="img-fluid" /> */}
                    <p>&nbsp;</p>
                </div>
            </div>
            <div className="projects-content mt-5">
                {projectsData.project.map( project => (
                    <div className="project py-4" key={project.id}>
                        <div className="project-content">
                            <NavLink 
                                to={'project/'+project.id}
                                onMouseEnter={() => cursorChangeHandler("hovered")}
                                onMouseLeave={() => cursorChangeHandler("")}
                                
                            >
                                <div className="project-content-title" data-aos="fade-up">
                                    <h1 className="mb-0">{project.name}</h1>
                                </div>
                            </NavLink>

                            <div className="project-content-location" data-aos="fade-up">
                                <p className="mb-0">
                                    <span>{project.place} - </span>
                                    <a 
                                        // to={'services/#'+project.serviceName}
                                        onMouseEnter={() => cursorChangeHandler("hovered")}
                                        onMouseLeave={() => cursorChangeHandler("")}
                                        rel="noreferrer noopener" 
                                        href={'services/#'+project.serviceName}
                                        
                                    >
                                        <span>{project.serviceName}</span>
                                    </a>
                                </p>
                            </div>

                            <div className="project-content-img pt-5  justify-content-start align-items-start d-md-flex d-none">
                                <div className="project-content-number px-2 mt-3" data-aos="fade-up" data-aos-delay="300">
                                    <p className="mb-1">{project.id}</p>
                                    <p className="mb-1">{projectsData.project.length}</p>
                                </div>
                                <div>
                                    <picture>
                                        <source media="(max-width:650px)" alt={project.imageAlt} srcSet={project.image[0].imagePathWebp}/>
                                        <img src={project.image[0].imagePath} alt={project.imageAlt} className="img-fluid"/>
                                    </picture>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <Form/>
        </section>
    )
}

export default Projects;